module.exports = __webpack_public_path__ + "static/media/builderContentTwo.2939b24e.svg";